import { z } from 'zod';

export const loginSchema = z.object({
    identifier: z.string().min(3, 'Username or email must be at least 3 characters'),
    password: z.string().min(6, 'Password must be at least 6 characters'),
    school_id: z.string().optional(),
    rememberMe: z.boolean(),
    is_super_admin: z.boolean().optional(),
    agreeTerms: z.boolean().refine(val => val === true, {
        message: 'You must agree to the terms and conditions',
    }),
}).refine(data => {
    if (data.is_super_admin) return true;
    if (!data.school_id) {
        return false;
    }
    return true;
}, {
    message: 'Please select a school',
    path: ['school_id']
}).refine(data => {
    if (data.is_super_admin && !data.identifier.includes('@')) {
        return false;
    }
    return true;
}, {
    message: 'Please enter a valid identifier for your role',
    path: ['identifier']
});

export type LoginFormValues = z.infer<typeof loginSchema>;
